export default function decimal(value, precision = 2, defaultValue = 'N/A') {
  const decimal = Number.parseFloat(value);
  return decimal >= 0 ? decimal.toFixed(precision) : defaultValue;
}
